export const USER_REG_FORM = "USER_REG_FORM";
export const INDEX_DATA_KNOWLAGE = "INDEX_DATA_KNOWLAGE"
export const CURRENT_AUDIO_URL = 'CURRENT_AUDIO_URL'



// WEBPACK FOOTER //
// ./src/store/types.js